import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'core/store/Store';
import { formatDate } from 'core/utils/DateUtils';

export interface ItinerayComparisonState {
  date: string;
  courier: number | null;
  leftClickedItineraryId: any;
  rightClickedItineraryId: any;
}

const initialState: ItinerayComparisonState = {
  date: formatDate(new Date()),
  courier: null,
  leftClickedItineraryId: null,
  rightClickedItineraryId: null,
};

export const itineraryComparisonSlice = createSlice({
  name: 'itineraryComparisonSlice',
  initialState,
  reducers: {
    setComparisonDate: (state, action: PayloadAction<string>) => ({
      ...state,
      date: action.payload,
    }),
    setComparisonCourierId: (state, action: PayloadAction<number | null>) => ({
      ...state,
      courier: action.payload,
    }),
    setLeftClickedItineraryId: (state, action: PayloadAction<any>) => ({
      ...state,
      leftClickedItineraryId: action.payload,
    }),
    setRightClickedItineraryId: (state, action: PayloadAction<any>) => ({
      ...state,
      rightClickedItineraryId: action.payload,
    }),
  },
});

export const selectDate = (state: RootState) =>
  state.itineraryComparisonReducer.date;
export const selectCourier = (state: RootState) =>
  state.itineraryComparisonReducer.courier;
export const selectLeftClickedItineraryId = (state: RootState) =>
  state.itineraryComparisonReducer.leftClickedItineraryId;
export const selectRightClickedItineraryId = (state: RootState) =>
  state.itineraryComparisonReducer.rightClickedItineraryId;
export const {
  setComparisonDate,
  setComparisonCourierId,
  setLeftClickedItineraryId,
  setRightClickedItineraryId,
} = itineraryComparisonSlice.actions;

export default itineraryComparisonSlice.reducer;
